export default __webpack_public_path__ + "static/media/11.8b822261.png";